{
    "common": {
        "mon": "Isnin",
        "tue": "Selasa",
        "wed": "Rabu",
        "thu": "Khamis",
        "fri": "Jumaat",
        "sat": "Sabtu",
        "sun": "Ahad",
        "jan": "Jan",
        "feb": "Feb",
        "mar": "Mac",
        "apr": "Apr",        
        "jun": "Jun",
        "jul": "Jul",
        "aug": "Ogos",
        "sep": "Sep",
        "oct": "Okt",
        "nov": "Nov",
        "dec": "Dis",
        "january": "Januari",
        "february": "Februari",
        "march": "Mac",
        "april": "April",
        "may": "Mei",
        "june": "Jun",
        "july": "Julai",
        "august": "Ogos", 
        "september": "September",
        "october": "Oktober",
        "november": "November",
        "december": "Disember",
        "checkin": "Daftar Masuk",
        "checkout": "Daftar Keluar",
        "room": "Bilik",
        "rooms": "Bilik",
        "adult": "Dewasa",
        "adults": "Dewasa",
        "edit": "Sunting",
        "editCap": "SUNTING",
        "delete":"Padam",
        "deleteCap":"PADAM",
        "localTime": "Masa Tempatan",
        "back": "KEMBALI",
        "home": "RUMAH",
        "yes": "YA",
        "no": "TIDAK",
        "left": "Tinggal",
        "hour": "Jam",
        "hours": "Jam",
        "night": "malam",
        "nights": "malam",
        "for": "untuk",
        "why": "Mengapa",
        "get": "Dapatkan",
        "more": "Lebih",
        "agree": "SETUJU",
        "disagree": "TIDAK SETUJU",
        "basedOn": "berdasarkan",
        "error": "Ralat berlaku, sila cuba lagi kemudian",
        "error2": "Gagal, cuba lagi!",
        "error3": "Ralat Berlaku!!",
        "error4": "Ralat berlaku!! Sila cuba lagi",
        "error5": "Maaf!! Ralat berlaku. Sila cuba lagi selepas beberapa ketika.",
        "hi": "Hai",
        "to": "kepada",
        "free": "Percuma",
        "per": "Setiap",
        "at": "pada",
        "day": "Hari",
        "days": "Hari",
        "time": "Masa",
        "of": "daripada",
        "photo": "Gambar",
        "photos": "Gambar",
        "done": "Selesai",
        "fullStay": "Penginapan Penuh",
        "date": "Tarikh",
        "and": "dan",
        "bookingDetail": "Butiran Tempahan",
        "Back": "Kembali",
        "Home": "Rumah"
    },
    "userPopup":{
        "myAccount": "Akaun Saya",
        "welcome": "Selamat Datang",
        "user": "Pengguna",
        "findMyBookings": "CARI TEMPAHAN SAYA",
        "viewProfile": "LIHAT PROFIL",
        "makeAReservarion": "BUAT TEMPAHAN",
        "logout": "LOG KELUAR",
        "loginCap": "LOG MASUK",
        "login": "Log Masuk",
        "invalidCredentials": "Kredensial tidak sah",
        "invalidEmail": "Emel tidak sah",
        "passwordIsRequired": "Kata laluan diperlukan",
        "minChar8":"minimum 8 aksara",
        "tooShort": "Terlalu Pendek!",
        "tooLong": "Terlalu Panjang!",
        "required": "Diperlukan",
        "emailInvalid":"Masukkan emel yang sah",
        "passwordInvalid":"Masukkan kata laluan yang sah",
        "phNumInvalid": "Nombor telefon tidak sah",
        "signupCap": "DAFTAR",
        "signup": "Daftar",
        "verifyText":"Sahkan bahawa ia adalah anda",
        "verifyText2":"Kami menghantar kod pengesahan ke emel anda",
        "verificationCode":"Kod Pengesahan",
        "didNotReceiveEmail": "Tidak menerima emel",
        "clickToResend": "Klik untuk hantar semula",
        "verifyAndSignIn": "Sahkan dan Log Masuk",
        "otpSentSuccessfully": "OTP dihantar dengan jayanya",
        "somethingWentWrong":  "Ralat berlaku, sila cuba lagi",
        "otpError": "Sila masukkan nombor yang sah",
        "otpError2":"Sila masukkan nombor sahaja",
        "otpError3": "OTP tidak betul, sila cuba lagi",
        "otpError4": "OTP Tamat Tempoh, klik Hantar Semula untuk cuba lagi",
        "otpError5": "Sila cuba lagi",
        "forgetPassword": "Lupa Kata Laluan",
        "submitError": "Pengguna tidak wujud!",
        "userExistError": "Pengguna Sudah Wujud",
        "checkYourEmail":  "Periksa emel anda",
        "passwordResetLinkSent": "Kami telah menghantar pautan reset kata laluan kepada",
        "noWorriesResetInstructions": "Jangan risau, kami akan hantar arahan reset kepada anda.",
        "enterYourEmail": "Masukkan emel anda",
        "resetMyPassword": "RESET KATA LALUAN SAYA",
        "setANewPassword": "Tetapkan kata laluan baharu",
        "newPassword": "Kata Laluan Baharu",
        "confirmPassword": "Sahkan Kata Laluan",
        "confirmPasswordError": "Kata laluan mesti sepadan",
        "backToLogin": "Kembali ke Log Masuk",
        "dontHaveAccount": "Tidak mempunyai akaun?",
        "alreadyHaveAccount": "Sudah mempunyai akaun?",
        "memberDiscount1": "Anda akan mendapat",
        "memberDiscount2": "diskaun ahli selama-lamanya.",
        "discount1": "Urus semua tempahan anda dari satu tempat.",
        "discount2": "Daftar untuk cadangan peribadi dan pengalaman yang disesuaikan!!",
        "discount3": "Sertai komuniti tetamu gembira kami dan mula merancang penginapan anda.",
        "leftGridText1": "Urus semua tempahan anda dari satu tempat",
        "leftGridText2": "Daftar untuk cadangan peribadi dan pengalaman yang disesuaikan!!",
        "leftGridText3": "Sertai komuniti tetamu gembira kami dan mula merancang penginapan anda",
        "gridDiscountText1": "diskaun ahli untuk",
        "gridDiscountText2": "harta terpilih selama-lamanya",
        "gridDiscountText3": "Log masuk untuk pengalaman yang disesuaikan selama-lamanya",
        "gridDiscountText4": "Dapatkan Faedah Ahli Eksklusif",
        "findBookingError": "Emel dan id tempahan anda tidak sepadan",
        "verifyAndConfirmBooking":"Sahkan dan sahkan tempahan",
        "confirmEmailText": "Kami telah menghantar kod pengesahan ke alamat e-mel anda",
        "enterCodeText":"Sila masukkan kod pengesahan yang dihantar kepada anda",
        "didNotRecieveEmail": "Tidak menerima emel?",
        "changeEmailText": "Klik di sini untuk menukar alamat e-mel",
        "verifyAndConfirm": "Sahkan dan Sahkan",
        "verified": "DISAHKAN",
        "bookingExpired": "Tempahan Tamat Tempoh",
        "bookingExpiredText": "Kami minta maaf, id tempahan yang anda gunakan telah tamat tempoh",
        "backToFindingBooking": "Kembali ke Cari Tempahan",
        "findMyBooking": "Cari Tempahan Saya",
        "bookingEmail": "Emel Tempahan",
        "reservationId": "Id Tempahan",
        "findBooking": "CARI TEMPAHAN",
        "abandonmentCartDoneText1": "Terima kasih!",
        "abandonmentCartDoneText2":"Butiran troli anda telah dihantar ke emel. Teruskan tempahan anda pada bila-bila masa.",
        "Recommended Currencies": "Mata Wang Disyorkan",
        "All currencies": "Semua mata wang",
        "thisIsRequiredField": "Ini adalah medan yang diperlukan"
    },
    "widget":{
        "destination": "Destinasi",
        "enterDestination": "Masukkan Destinasi",
        "guests": "Tetamu",
        "nationality": "Kewarganegaraan",
        "selectNationality": "Pilih kewarganegaraan",
        "nationalityIsRequired": "Kewarganegaraan diperlukan",
        "selectedRate": "Kadar khas",
        "search": "Cari",
        "ages": "Umur",
        "orAbove": "Atau Lebih",
        "child": "Kanak-kanak",
        "children": "Kanak-kanak",
        "addAnotherRoom": "Tambah Bilik Lain",
        "removeRoom": "Buang Bilik",
        "property": "Harta",
        "city": "Bandar",
        "country": "Negara",
        "bookNow": "Tempah Sekarang",
        "overnightStay": "Penginapan Semalaman",
        "dayUse": "Penggunaan Harian",
        "destinationIsRequired": "Destinasi diperlukan",
        "checkInIsRequired": "Tarikh daftar masuk diperlukan",
        "checkOutIsRequired": "Tarikh daftar keluar diperlukan",
        "noLocationFound": "Tiada Lokasi Dijumpai",
        "soldOut": "Habis dijual",
        "highDemand": "Permintaan Tinggi",
        "dates": "Tarikh",
        "allRates": "Semua kadar dalam",
        "K": "K",
        "M": "M",
        "sameDayCheckout": "Daftar keluar hari yang sama"
    },
    "promotion": {
        "headingText": "Maklumat Penting untuk",
        "regularRate": "Tiada",
        "seniorCitizen": "Kadar Warga Emas",
        "agencyRate": "Kadar Agensi",
        "caaRate": "Kadar CAA/AAA",
        "corporateRate": "Kadar Korporat",
        "governmentRate": "Kadar Kerajaan/Tentera",
        "promotionalSpecialRate": "Kadar Promosi/Khas",
        "regularRateDescription": "Tiada promosi digunakan.",
        "seniorCitizenRateDescription": "Ini adalah kadar hotel diskaun yang tersedia secara meluas untuk warga emas, biasanya berumur 60 tahun ke atas.",
        "agencyRateDescription": "Ini adalah kadar hotel diskaun yang ditawarkan yang boleh diakses melalui ejen pelancongan tertentu sahaja untuk memupuk perkongsian dan kerjasama.",
        "caaRateDescription": "Ini adalah kadar hotel khas yang ditawarkan kepada ahli AAA atau CAA untuk penjimatan eksklusif.",
        "corporateRateDescription": "Ini adalah kadar hotel diskaun yang diperluaskan kepada pelancong perniagaan, biasanya dirundingkan antara hotel dan entiti korporat.",
        "governmentRateDescription": "Pelan kadar ini menawarkan diskaun khusus untuk kakitangan Kerajaan/Tentera untuk menempah bilik hotel.",
        "contentSeniorCitizen": "Bukti tarikh lahir adalah wajib pada masa daftar masuk. Kegagalan untuk mengemukakan ID yang berkaitan akan mengakibatkan caj kadar semasa.",
        "contentAgencyRate": "Pastikan anda mempunyai pengesahan tempahan dan bukti ID semasa ketibaan. Kegagalan untuk mengemukakan ini akan mengakibatkan kadar standard dikenakan.",
        "contentPromotionalSpecialRate": "Ini adalah kadar hotel diskaun yang ditawarkan untuk tempoh terhad, selalunya dikaitkan dengan acara, musim, atau kempen pemasaran tertentu.",
        "contentCaaRate": "Sila pastikan anda mempunyai kad keahlian CAA atau pengenalan yang berkaitan pada masa daftar masuk. Kegagalan untuk mengemukakan ID yang berkaitan akan mengakibatkan caj kadar semasa.",
        "contentCorporateRate": "Bukti ID syarikat atau dokumentasi rasmi lain diperlukan pada masa daftar masuk. Kegagalan untuk mengemukakan bukti yang berkaitan akan mengakibatkan caj kadar semasa.",
        "contentGovernmentRate": "ID kerajaan atau tentera yang sah mesti disediakan semasa daftar masuk. Kegagalan untuk menyediakan pengenalan yang diperlukan akan mengakibatkan caj pada kadar standard.",
        "CORP": "CORP",
        "AGEN": "AGEN",
        "PROM": "PROM",
        "apply": "GUNAKAN",
        "Offer Code": "Kod Tawaran",
        "Agency Code": "Kod Agensi",
        "Corporate Code": "Kod Korporat",
        "All-Access Rate": "Kadar Akses Semua",
        "errorCode": "Kod ini tidak sah"
    }
} 